export default {
    props: {
        seriesDefaultsArea: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.area'
        }, 
        seriesDefaultsBar: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.bar'
        }, 
        seriesDefaultsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.border.color'
        }, 
        seriesDefaultsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.border.dashType'
        }, 
        seriesDefaultsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.border.width'
        }, 
        seriesDefaultsBubble: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.bubble'
        }, 
        seriesDefaultsCandlestick: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.candlestick'
        }, 
        seriesDefaultsColumn: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.column'
        }, 
        seriesDefaultsDonut: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.donut'
        }, 
        seriesDefaultsGap: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.gap'
        }, 
        seriesDefaultsLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.background'
        }, 
        seriesDefaultsLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.border.color'
        }, 
        seriesDefaultsLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.border.dashType'
        }, 
        seriesDefaultsLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.border.width'
        }, 
        seriesDefaultsLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.color'
        }, 
        seriesDefaultsLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.font'
        }, 
        seriesDefaultsLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.format'
        }, 
        seriesDefaultsLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.margin'
        }, 
        seriesDefaultsLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.margin.bottom'
        }, 
        seriesDefaultsLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.margin.left'
        }, 
        seriesDefaultsLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.margin.right'
        }, 
        seriesDefaultsLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.margin.top'
        }, 
        seriesDefaultsLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.padding'
        }, 
        seriesDefaultsLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.padding.bottom'
        }, 
        seriesDefaultsLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.padding.left'
        }, 
        seriesDefaultsLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.padding.right'
        }, 
        seriesDefaultsLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.padding.top'
        }, 
        seriesDefaultsLabelsRotation: {
            type: [String, Number],
            default: undefined,
            kComposite: 'seriesDefaults.labels.rotation'
        }, 
        seriesDefaultsLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.labels.template'
        }, 
        seriesDefaultsLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.labels.visible'
        }, 
        seriesDefaultsLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'seriesDefaults.labels.visual'
        }, 
        seriesDefaultsLabelsFromBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.background'
        }, 
        seriesDefaultsLabelsFromBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.border.color'
        }, 
        seriesDefaultsLabelsFromBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.border.dashType'
        }, 
        seriesDefaultsLabelsFromBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.border.width'
        }, 
        seriesDefaultsLabelsFromColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.color'
        }, 
        seriesDefaultsLabelsFromFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.font'
        }, 
        seriesDefaultsLabelsFromFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.format'
        }, 
        seriesDefaultsLabelsFromMargin: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.margin'
        }, 
        seriesDefaultsLabelsFromMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.margin.bottom'
        }, 
        seriesDefaultsLabelsFromMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.margin.left'
        }, 
        seriesDefaultsLabelsFromMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.margin.right'
        }, 
        seriesDefaultsLabelsFromMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.margin.top'
        }, 
        seriesDefaultsLabelsFromPadding: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.padding'
        }, 
        seriesDefaultsLabelsFromPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.padding.bottom'
        }, 
        seriesDefaultsLabelsFromPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.padding.left'
        }, 
        seriesDefaultsLabelsFromPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.padding.right'
        }, 
        seriesDefaultsLabelsFromPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.padding.top'
        }, 
        seriesDefaultsLabelsFromTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.template'
        }, 
        seriesDefaultsLabelsFromVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.labels.from.visible'
        }, 
        seriesDefaultsLabelsToBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.background'
        }, 
        seriesDefaultsLabelsToBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.border.color'
        }, 
        seriesDefaultsLabelsToBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.border.dashType'
        }, 
        seriesDefaultsLabelsToBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.border.width'
        }, 
        seriesDefaultsLabelsToColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.color'
        }, 
        seriesDefaultsLabelsToFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.font'
        }, 
        seriesDefaultsLabelsToFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.format'
        }, 
        seriesDefaultsLabelsToMargin: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.margin'
        }, 
        seriesDefaultsLabelsToMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.margin.bottom'
        }, 
        seriesDefaultsLabelsToMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.margin.left'
        }, 
        seriesDefaultsLabelsToMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.margin.right'
        }, 
        seriesDefaultsLabelsToMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.margin.top'
        }, 
        seriesDefaultsLabelsToPadding: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.padding'
        }, 
        seriesDefaultsLabelsToPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.padding.bottom'
        }, 
        seriesDefaultsLabelsToPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.padding.left'
        }, 
        seriesDefaultsLabelsToPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.padding.right'
        }, 
        seriesDefaultsLabelsToPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.padding.top'
        }, 
        seriesDefaultsLabelsToTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.template'
        }, 
        seriesDefaultsLabelsToVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.labels.to.visible'
        }, 
        seriesDefaultsLine: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.line'
        }, 
        seriesDefaultsOhlc: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.ohlc'
        }, 
        seriesDefaultsOverlayGradient: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.overlay.gradient'
        }, 
        seriesDefaultsPie: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.pie'
        }, 
        seriesDefaultsRangeArea: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.rangeArea'
        }, 
        seriesDefaultsScatter: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.scatter'
        }, 
        seriesDefaultsScatterLine: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.scatterLine'
        }, 
        seriesDefaultsSpacing: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.spacing'
        }, 
        seriesDefaultsStack: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.stack'
        }, 
        seriesDefaultsStackType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.stack.type'
        }, 
        seriesDefaultsType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.type'
        }, 
        seriesDefaultsTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.background'
        }, 
        seriesDefaultsTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.border.color'
        }, 
        seriesDefaultsTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.border.width'
        }, 
        seriesDefaultsTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.color'
        }, 
        seriesDefaultsTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.font'
        }, 
        seriesDefaultsTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.format'
        }, 
        seriesDefaultsTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.padding'
        }, 
        seriesDefaultsTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.padding.bottom'
        }, 
        seriesDefaultsTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.padding.left'
        }, 
        seriesDefaultsTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.padding.right'
        }, 
        seriesDefaultsTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.padding.top'
        }, 
        seriesDefaultsTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.template'
        }, 
        seriesDefaultsTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.tooltip.visible'
        }, 
        seriesDefaultsVerticalArea: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.verticalArea'
        }, 
        seriesDefaultsVerticalLine: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.verticalLine'
        }, 
        seriesDefaultsVerticalRangeArea: {
            type: Object,
            default: undefined,
            kComposite: 'seriesDefaults.verticalRangeArea'
        }, 
        seriesDefaultsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'seriesDefaults.visual'
        }, 
        seriesDefaultsNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.icon.background'
        }, 
        seriesDefaultsNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.icon.border.color'
        }, 
        seriesDefaultsNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.notes.icon.border.width'
        }, 
        seriesDefaultsNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.notes.icon.size'
        }, 
        seriesDefaultsNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.icon.type'
        }, 
        seriesDefaultsNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.notes.icon.visible'
        }, 
        seriesDefaultsNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.background'
        }, 
        seriesDefaultsNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.border.color'
        }, 
        seriesDefaultsNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.border.dashType'
        }, 
        seriesDefaultsNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.border.width'
        }, 
        seriesDefaultsNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.color'
        }, 
        seriesDefaultsNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.font'
        }, 
        seriesDefaultsNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.template'
        }, 
        seriesDefaultsNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.visible'
        }, 
        seriesDefaultsNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.rotation'
        }, 
        seriesDefaultsNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.format'
        }, 
        seriesDefaultsNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.label.position'
        }, 
        seriesDefaultsNotesLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.line.dashType'
        }, 
        seriesDefaultsNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.notes.line.width'
        }, 
        seriesDefaultsNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.notes.line.color'
        }, 
        seriesDefaultsNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.notes.line.length'
        }, 
        seriesDefaultsNotesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'seriesDefaults.notes.visual'
        },
        seriesDefaultsDynamicSlope: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.dynamicSlope'
        },
        seriesDefaultsDynamicHeight: {
            type: Boolean,
            default: undefined,
            kComposite: 'seriesDefaults.dynamicHeight'
        },
        seriesDefaultsStartAngle: {
            type: Number,
            default: undefined,
            kComposite: 'seriesDefaults.startAngle'
        },
        seriesDefaultsStyle: {
            type: String,
            default: undefined,
            kComposite: 'seriesDefaults.style'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/SeriesDefaults.js